import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
// import getImageUrl from "../../../utils/helpers/get-image-url";
// import appStore from "./images/app-store.svg";
import Facebook from "./images/facebook.svg";
import x from "./images/x.svg";
import Instagram from "./images/instagram.svg";
import LinkedIn from "./images/linkedin.svg";
import YouTube from "./images/youtube.svg";
import { NUMBER, SOCIAL_MEDIA_KEYS } from "../../../constants/app-constants";

const SocialIcon = ({ name, shape, backgroundColor, size = NUMBER.THIRTY_TWO }) => {

    const getURL = () => {
        switch (name) {
        case SOCIAL_MEDIA_KEYS.FACEBOOK:
            return Facebook;
        case SOCIAL_MEDIA_KEYS.X:
            return x;
        case SOCIAL_MEDIA_KEYS.INSTAGRAM:
            return Instagram;
        case SOCIAL_MEDIA_KEYS.LINKEDIN:
            return LinkedIn;
        case SOCIAL_MEDIA_KEYS.YOUTUBE:
            return YouTube;
        }
        return "";
    };

    const getStyle = () => {
        if (shape === "round") {
            return "styles.round";
        }
        return "";
    };

    return (
        <img
            src={getURL()}
            alt={name}
            style={{
                backgroundColor,
                width: size,
                height: size,
                padding: 8,
                boxSizing: "border-box"
            }}
            styleName={getStyle()}
        />);
};

SocialIcon.propTypes = {
    name: PropTypes.string.isRequired,
    shape: PropTypes.string,
    backgroundColor: PropTypes.string,
    size: PropTypes.number
};

export default SocialIcon;
